import { render, staticRenderFns } from "./m_picker.vue?vue&type=template&id=5d8762a4&scoped=true"
import script from "./m_picker.vue?vue&type=script&lang=js"
export * from "./m_picker.vue?vue&type=script&lang=js"
import style0 from "./m_picker.vue?vue&type=style&index=0&id=5d8762a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8762a4",
  null
  
)

export default component.exports